import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import type { SectionProps } from './Section';

export interface TimeProps
  extends Pick<SectionProps, 'Icon' | 'time' | 'variant'> {
  readonly className?: string;
}

const Time = ({ className, Icon, time, variant }: TimeProps) => {
  const t = useTranslations();
  return (
    <div
      className={cx(
        'flex items-center gap-x-4 text-sandstone-200 lg:text-current',
        {
          // On mobile this is always overlaying the video/image so it always uses sandstone-200
          'lg:text-sandstone-500': variant.lg === 'light',
        },
        className,
      )}
      data-cy="timeline_section_time"
    >
      <Icon className="inline-block size-6" />
      <Typography
        className="pt-px text-sm leading-none tracking-wide lg:text-base"
        color="inherit"
        Element="span"
        weight="bold"
      >
        {t(time)}
      </Typography>
    </div>
  );
};

export default Time;
